import { render, staticRenderFns } from "./CoreMenuOption.vue?vue&type=template&id=d7ec720e&scoped=true&"
import script from "./CoreMenuOption.vue?vue&type=script&lang=js&"
export * from "./CoreMenuOption.vue?vue&type=script&lang=js&"
import style0 from "./CoreMenuOption.vue?vue&type=style&index=0&id=d7ec720e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ec720e",
  null
  
)

component.options.__file = "CoreMenuOption.vue"
export default component.exports